import { Category } from 'config/enums';
import { getTemplateLang, getSubId } from 'config/client';
import { getProviderConfig, getRefProvider } from 'config/providers';
import { resolveTemplateId } from './templateResolver';

export const getTemplateIdForCategory = (category: Category): string => {
  const lang = getTemplateLang();
  const subId = getSubId();
  const provider = getRefProvider();
  const providerConfig = getProviderConfig();

  return resolveTemplateId({
    context: { provider, category, lang, subId },
    config: providerConfig,
  });
};
